import { Component, Input } from '@angular/core';

/**
 * Centered Container Component
 *
 * Responsive centered layout container.
 * Stacks vertically on mobile, centered on desktop.
 */
@Component({
  selector: 'app-centered-container',
  standalone: true,
  imports: [],
  template: `
    <div class="centered-container" [class.full-height]="fullHeight">
      <div class="centered-content" [style.max-width.px]="maxWidth">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .centered-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: var(--aida-ref-spacing-300);
      background-color: var(--aida-colour-surface-canvas);
    }

    .centered-container.full-height {
      min-height: 100vh;
    }

    .centered-content {
      width: 100%;
    }

    /* Mobile responsiveness */
    @media (max-width: 600px) {
      .centered-container {
        padding: var(--aida-ref-spacing-200);
        align-items: flex-start;
      }

      .centered-content {
        max-width: 100% !important;
      }
    }
  `],
})
export class CenteredContainerComponent {
  @Input() maxWidth = 400;
  @Input() fullHeight = true;
}
